<script lang="ts">

    const year = new Date().getFullYear()

</script>

echeide.com {year}
